export default __webpack_public_path__ + "static/media/driver1.171a90bf.jpg";